import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ready: false,
  poiList: [],
  selectedPoiId: '',
  map: {
    center: {
      lat: 0,
      lng: 0
    },
    style: '',
    project: {
      lat: 0,
      lng: 0
    }
  },
  filters: {
    typeList: []
  },
  travelMode: 'drive',
  architecture: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/neighbourhood/index.js